/** @jsx createElement */
import { observer } from 'mobx-react';
import { createElement, Component, HTMLAttributes } from 'react';
import { Template__CompareNetworkToNetwork } from '../../templates/compare-network-to-network';

@observer
export class Slide05 extends Component {
  componentDidMount() {
    // Do something
  }

  render() {
    const { children } = this.props;
    return (
      <div className={`slide-05`}>
        {children}
        <Template__CompareNetworkToNetwork label={'Shodan'} />
      </div>
    );
  }
}
